import { Utilities } from './../../providers/utilities';
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { reorderArray, Item } from 'ionic-angular';

@Component({
  selector: "app-widgets-right",
  templateUrl: "widgets-right.html",
})
export class WidgetsRightComponent {

  @Input() public widgets: any[];
  @Input() public defaultLanguage: string;
  @Input() public language: string;
  @Output() public languageChange = new EventEmitter();
  @Output() public emitWidget = new EventEmitter();
  @Output() public emitWidgets = new EventEmitter();

  public isReorder = false;
  public isForm = false;
  public currentWidget = null;

  constructor(
    private utilities: Utilities,
  ) { }

  public selected(event) {
    this.languageChange.emit(event);
  }

  public reorderItems(indexes) {
    const load = this.utilities.setLoading();

    return Promise.resolve()
      .then(() => reorderArray(this.widgets, indexes))
      .then((newWidgets) => newWidgets.map((item, key) => ({ ...item, order: key })))
      .then((newWidgets) => this.emitWidgets.emit(newWidgets))
      .then(() => load.dismiss());
  }

  public addOrUpdate(current = null) {
    const load = this.utilities.setLoading();

    return Promise.resolve()
      .then(() => {
        if (current) {
          this.currentWidget = current;
        } else {
          this.currentWidget = null;
        }
        return true;
      })
      .then(() => this.isForm = true)
      .then(() => load.dismiss());
  }

  public createOrUpdateWidget(widget) {
    const load = this.utilities.setLoading();
    return Promise.resolve()
      .then(() => this.emitWidget.emit(widget))
      .then(() => this.isForm = false)
      .then(() => load.dismiss());
  }
}

// order: number;
// title: I18n;
// type: string; // TODO: definir cuales son las opciones de suggestions habilitads
// background?: string;
// data_widget?: any;



// WEBPACK FOOTER //
// ./src/components/widgets-right/widgets-right.ts